/** Format Gregorian ISO date with optional Hijri secondary line (ar-SA islamic calendar). */
export function formatWithHijri(isoDate: string, showHijri: boolean, locale: string): string {
  const d = new Date(`${isoDate}T12:00:00`);
  const greg = d.toLocaleDateString(locale.startsWith('ar') ? 'ar-EG-u-nu-latn' : 'en-GB', {
    numberingSystem: 'latn'
  });
  if (!showHijri) return greg;
  try {
    const hijri = d.toLocaleDateString('ar-SA-u-ca-islamic-u-nu-latn', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      numberingSystem: 'latn'
    });
    return `${greg} · ${hijri}`;
  } catch {
    return greg;
  }
}
